export default [
    { value: 0, label: '请选择分类' },
    { value: 1, label: '产出指标' },
    { value: 2, label: '效益指标' },
    { value: 3, label: '满意度指标' },
];
